import { useContext } from 'react';
import { CandidateContext } from '@authentication/contexts/candidateContext';

const useCandidate = () => {
  const context = useContext(CandidateContext);
  if (!context) {
    throw new Error('useCandidate must be used within a UserProvider');
  }
  return context;
};

export default useCandidate;
